module.exports = __webpack_public_path__ + "filetype-archive.svg?d71a9f9fbf3499249fb8c73eb6820d95";